import { cn } from '@/lib/utils/cn';

const OPERATORS_BY_COUNTRY: Record<string, { code: string; label: string }[]> = {
  JO: [
    { code: 'ZAIN', label: 'Zain' },
    { code: 'UMNIAH', label: 'Umniah' },
    { code: 'ORANGE', label: 'Orange' },
  ],
  SA: [
    { code: 'STC', label: 'STC' },
    { code: 'MOBILY', label: 'Mobily' },
    { code: 'ZAIN', label: 'Zain' },
  ],
  AE: [
    { code: 'ETISALAT', label: 'Etisalat' },
    { code: 'DU', label: 'du' },
  ],
  EG: [
    { code: 'VODAFONE', label: 'Vodafone' },
    { code: 'WE', label: 'WE' },
    { code: 'ORANGE', label: 'Orange' },
  ],
};

const ALL_OPERATORS = [
  { code: 'STC', label: 'STC' },
  { code: 'MOBILY', label: 'Mobily' },
  { code: 'ZAIN', label: 'Zain' },
  { code: 'ORANGE', label: 'Orange' },
  { code: 'UMNIAH', label: 'Umniah' },
  { code: 'ETISALAT', label: 'Etisalat' },
  { code: 'DU', label: 'du' },
  { code: 'VODAFONE', label: 'Vodafone' },
  { code: 'WE', label: 'WE' },
];

interface OperatorSelectProps {
  value: string;
  onChange: (code: string) => void;
  countryCode?: string;
  className?: string;
  placeholder?: string;
}

export function OperatorSelect({
  value,
  onChange,
  countryCode,
  className,
  placeholder = 'All Operators',
}: OperatorSelectProps) {
  const operators = countryCode
    ? (OPERATORS_BY_COUNTRY[countryCode] ?? ALL_OPERATORS)
    : ALL_OPERATORS;

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        'rounded-lg border border-border bg-surface px-3 py-1.5 text-sm text-fg',
        'focus:outline-none focus:ring-2 focus:ring-primary-500/30',
        className,
      )}
    >
      <option value="">{placeholder}</option>
      {operators.map(({ code, label }) => (
        <option key={code} value={code}>
          {label}
        </option>
      ))}
    </select>
  );
}
